import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireBambooPortfolio } from "/Users/mbutleruk/Dropbox/Sites/bamboomanchester/app/public/wp-content/themes/bamboo/modules/portfolio/bamboo-portfolio.js";
var bambooPortfolioExports = requireBambooPortfolio();
export { bambooPortfolioExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(bambooPortfolioExports);